export const BASE_URL = process.env.NODE_ENV === "production" ? "https://tickt-backend.herokuapp.com/" : "http://localhost:3000"
